import isEmpty from 'lodash/isEmpty';
export const _isEmpty = isEmpty;
